angular.module('FlexyBeautyApp.controllers').
controller('CompanyImageCtrl', ["$scope", "$dialog", "$timeout","CompanyImageData","CompanyImageSrv",
    function($scope,$dialog,$timeout,CompanyImageData,CompanyImageSrv)
    {
        const MAX_IMAGES_DISPLAYED_ON_SCROLL = 100;
        $scope.dd.view.companyImagesView = [];
        $scope.dd.view.companyImagesViewDisplayed = [];
        $scope.dd.view.imageUploadRunning = false;

        $scope.$watch('ad.dataLoaded', function(newValue)
        {
            if (newValue)
            {
                $scope.dd.view.companyImagesView = CompanyImageData.companyImages;
                $scope.addMoreCompanyImage();
            }
        });

        $scope.addCompanyImagesViewDisplayed = function(companyImageView) {
            if (companyImageView && $scope.dd.view.companyImagesViewDisplayed.indexOf(companyImageView) === -1) {
                $scope.dd.view.companyImagesViewDisplayed.push(companyImageView);
            }
        };

        $scope.addMoreCompanyImage = function(){
            if ($scope.dd.view.companyImagesViewDisplayed && $scope.dd.view.companyImagesView) {
                let initialSize = $scope.dd.view.companyImagesViewDisplayed.length;
                let numberOfImagesToDisplay = initialSize + MAX_IMAGES_DISPLAYED_ON_SCROLL;
                for (let i = initialSize; i < $scope.dd.view.companyImagesView.length && i < numberOfImagesToDisplay; i++) {
                    $scope.addCompanyImagesViewDisplayed($scope.dd.view.companyImagesView[i]);
                }
            }
        };

        $scope.removeImageViewFromEditedItem  = function(editedItemView, companyImage)
        {
            if (editedItemView)
            {
                let opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl:  '/partials/global/removeConfirm.html',
                    controller: 'DialogCtrl' ,
                    resolve: {
                        dialogsModel: function() {
                            let tableModel = [] ;
                            tableModel["label"] = companyImage.label;
                            return tableModel;
                        }
                    }
                };
                let d = $dialog.dialog(opts);
                d.open().then(function(result){
                    if (result)
                    {
                        let index = $scope.dd.view.companyImagesViewDisplayed.indexOf(companyImage);
                        if (index !== -1)
                        {
                            $scope.dd.view.companyImagesViewDisplayed.splice(index,1);
                        }
                        let indexDisplay = $scope.dd.view.companyImagesView.indexOf(companyImage);
                        if (indexDisplay !== -1)
                        {
                            $scope.dd.view.companyImagesView.splice(index,1);
                            CompanyImageSrv.remove(companyImage);
                        }

                    }
                });
            }
        };

        $scope.onUploadCompanyImageSuccess  = function(editedItemView, message)
        {
            try {
                let companyImage = JSON.parse(message);
                $scope.dd.view.imageUploadRunning = false;
                if (editedItemView && editedItemView.setCompanyImage)
                    editedItemView.setCompanyImage(companyImage);
                if (companyImage) {
                    CompanyImageData.add(companyImage);
                    $scope.dd.view.companyImagesViewDisplayed.push(companyImage);
                }
            } catch (e) {
                console.log('onUploadCompanyImageSuccess JSON.parse error', e);
            }
        };

        $scope.onStartUploadImage  = function()
        {
            $scope.dd.view.imageUploadRunning = true;
        };

    }]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/pr/CompanyImageCtrl.js